<template>
    <div>
        <form-header title="Anmeldung zum Tag der Admin"> </form-header>
        <div class="bg-primary">
            <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                <ValidationObserver ref="form">
                    <form-section title="Angaben zur Musikschule">
                        <drop-down
                            rules="required"
                            :values="formdata.musikschulen"
                            label="Musikschule"
                            v-model="ansuchen.musikschuleId"
                        ></drop-down>
                    </form-section>
                    <form-section title="Angaben zur Person">
                        <text-input
                            columns="2"
                            label="Titel vorangestellt"
                            v-model="ansuchen.titelVor"
                        ></text-input>
                        <text-input
                            columns="2"
                            label="Titel nachgestellt"
                            v-model="ansuchen.titelNach"
                        ></text-input>
                        <text-input
                            rules="required"
                            columns="3"
                            label="Vorname"
                            v-model="ansuchen.vorname"
                        ></text-input>
                        <text-input
                            rules="required"
                            columns="3"
                            label="Nachname"
                            v-model="ansuchen.nachname"
                        ></text-input>
                        <text-input
                            rules="required|email"
                            label="E-Mail"
                            v-model="ansuchen.email"
                        ></text-input>
                    </form-section>
                    <form-section title="Workshops" v-if="false">
                        <drop-down
                            rules="required"
                            :values="workshops1"
                            columns="3"
                            label="1. Workshop"
                            v-model="ansuchen.workshop1Id"
                        ></drop-down>
                        <text-input
                            columns="3"
                            label="Fragen"
                            v-model="ansuchen.workshop1Fragen"
                        ></text-input>
                        <drop-down
                            rules="required"
                            :values="workshops2"
                            columns="3"
                            label="2. Workshop"
                            v-model="ansuchen.workshop2Id"
                        ></drop-down>
                        <text-input
                            columns="3"
                            label="Fragen"
                            v-model="ansuchen.workshop2Fragen"
                        ></text-input>
                    </form-section>
                    <form-section title="Allgemeine Anmerkungen/Fragen- und Themenwünsche">
                        <text-area-input
                            label=""
                            v-model="ansuchen.themenwuensche"
                            columns="6"
                            rows="5"
                        ></text-area-input>
                    </form-section>
                    <form-section title="Anmerkungen">
                        <text-area-input
                            label=""
                            v-model="ansuchen.anmerkungen"
                            columns="6"
                            rows="5"
                        ></text-area-input>
                    </form-section>
                    <form-section title="Rechnungsadresse" subtitle="für Tagungspauschale (EUR 20,00 pro Person)" v-if="false">
                        <text-input
                            columns="4"
                            label="Name d. Adressaten"
                            v-model="ansuchen.rechnungsAdressat"
                            rules="required"
                        ></text-input>
                        <text-input
                            columns="4"
                            label="Adresse"
                            v-model="ansuchen.rechnungsAdresse"
                            rules="required"
                        ></text-input>
                        <text-input
                            rules="required"
                            columns="3"
                            label="Postleitzahl"
                            v-model="ansuchen.rechnungsPlz"
                        ></text-input>
                        <text-input
                            rules="required"
                            columns="3"
                            label="Ort"
                            v-model="ansuchen.rechnungsOrt"
                        ></text-input>
                        <text-input
                            rules="required|email"
                            label="E-Mail"
                            v-model="ansuchen.rechnungsEmail"
                        ></text-input>
                    </form-section>
                     <form-section title="Information zur Datenverarbeitung">
                        <text-block :content="textbausteinfuer('allgemein.informationspflicht')" class="col-span-6"></text-block> 
                    </form-section>
                    <div
                        class="
                            mt-6
                            bg-white
                            shadow
                            px-4
                            py-5
                            sm:rounded-lg sm:p-6
                        "
                    >
                        <div class="sm:grid sm:grid-cols-3 sm:gap-6">
                            <div class="sm:col-span-1">&nbsp;</div>
                            <span class="inline-flex rounded-md shadow-sm">
                                <button
                                    @click="sendAnsuchen()"
                                    type="button"
                                    class="
                                        inline-flex
                                        items-center
                                        px-48
                                        sm:px-8
                                        py-2
                                        border border-transparent
                                        text-base
                                        leading-6
                                        font-medium
                                        rounded-md
                                        text-white
                                        bg-green-600
                                        hover:bg-green-500
                                        focus:outline-none
                                        focus:border-indigo-700
                                        focus:shadow-outline-green
                                        active:bg-green-700
                                        transition
                                        ease-in-out
                                        duration-150
                                    "
                                >
                                    Anmeldung absenden
                                </button>
                            </span>
                        </div>
                    </div>
                </ValidationObserver>
                <success-modal
                    text="Sie erhalten in Kürze eine Email. Sie können das Fenster nun schließen."
                    v-if="formbehaviour.successful"
                ></success-modal>
                <sending-modal v-if="formbehaviour.sending"></sending-modal>
            </div>
        </div>
    </div>
</template>
<script>
import FormHeader from '@/components/forms/FormHeader.vue'
import FormSection from '@/components/forms/FormSection.vue'
import TextInput from '@/components/inputs/TextInput.vue'
import TextAreaInput from '@/components/inputs/TextAreaInput.vue'
import DropDown from '@/components/inputs/DropDown.vue'
import SuccessModal from '@/components/modals/SuccessModal.vue'
import SendingModal from '@/components/modals/SendingModal.vue'
import TextBlock from '@/components/inputs/TextBlock.vue'

export default {
    name: 'Form',
    inject: ['service'],
    props: {
        datum: {
            type: String,
            required: true,
        },
    },
    data: function () {
        return {
            formdata: {
                musikschulen: [],
                workshops: [],
                textbausteine: [],
            },
            formbehaviour: {
                sending: false,
                successful: false,
            },
            ansuchen: {
                datum: null,
                musikschuleId: null,
                vorname: null,
                nachname: null,
                titelVor: null,
                titelNach: null,
                email: null,
                themenwuensche: null,
                anmerkungen: null,
                workshop1Id: null,
                workshop2Id: null,
                workshop1Fragen: null,
                workshop2Fragen: null,
                rechnungsAdressat: null,
                rechnungsAdresse: null,
                rechnungsPlz: null,
                rechnungsOrt: null,
                rechnungsEmail: null,
            },
        }
    },
    computed: {
        workshops1() {
            return this.formdata.workshops.filter((el) => el.id != this.ansuchen.workshop2Id);
        },
        workshops2() {
            return this.formdata.workshops.filter((el) => el.id != this.ansuchen.workshop1Id);
        },
    },
    methods: {
        async fetchMusikschulen() {
            const { data } = await this.service.musikschule.powerAppsAlle()
            this.formdata.musikschulen = data
            this.formdata.musikschulen.sort((a, b) =>
                a.kurzbezeichnung > b.kurzbezeichnung ? 1 : -1
            )
        },
        async fetchWorkshops() {
            const { data } = await this.service.tdaworkshops.alle()
            this.formdata.workshops = data
            this.formdata.workshops.sort((a, b) => (a.name > b.name ? 1 : -1))
        },
        async sendAnsuchen() {
            var validation = await this.$refs.form.validate()

            if (!validation) {
                window.scrollTo(0, 0)
                return
            }

            this.formbehaviour.sending = true
            await this.service.tda.senden(this.ansuchen)
            this.formbehaviour.sending = false
            this.formbehaviour.successful = true
        },
        async fetchTextbausteine() {
            const { data } = await this.service.formular
                .get('tda')
                .textbloecke();
            this.formdata.textbausteine = data;
        },
        textbausteinfuer(id) {
            const found = this.formdata.textbausteine.find(
                element => element.identifier == id
            );
            if (!found) return id;

            return found.content;
        },
    },
    created() {
        this.ansuchen.datum = this.datum
        this.fetchMusikschulen()
        this.fetchWorkshops()
        this.fetchTextbausteine()
    },
    components: {
        FormHeader,
        FormSection,
        TextInput,
        TextAreaInput,
        DropDown,
        SuccessModal,
        SendingModal,
        TextBlock,
    },
}
</script>